import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { RefrigerationGroup } from '../../models/refrigeration-group';
import { RefrigerationGroupBuilder } from '../../models/builders/refrigeration-group.builder';

const refrigerationGroupBody = (refrigerationGroup: RefrigerationGroup) => ({
  name: refrigerationGroup.name,
  refrigerations: refrigerationGroup.refrigerations
});

@Injectable()
export class RefrigerationGroupApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }refrigerationGroups`;
  }

  createRefrigerationGroup(refrigerationGroup) {
    return this.httpClient.post(this.apiUrl, refrigerationGroupBody(refrigerationGroup)).pipe(map(RefrigerationGroupBuilder.fromJson));
  }

  deleteRefrigerationGroup(refrigerationGroup: RefrigerationGroup) {
    return this.httpClient.delete(`${ this.apiUrl }/${ refrigerationGroup.hash }`);
  }

  getRefrigerationGroups() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(RefrigerationGroupBuilder.fromList));
  }

  getRefrigerationGroup(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(RefrigerationGroupBuilder.fromJson));
  }

  updateRefrigerationGroup(refrigerationGroup: RefrigerationGroup) {
    return this.httpClient.put(`${ this.apiUrl }/${ refrigerationGroup.hash }`, refrigerationGroupBody(refrigerationGroup));
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/refrigeration-group-api.service.ts